import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
import { truncate } from 'flarum/common/utils/string';

export default class BeHideNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return '';
  }

  href() {
    if (!this.attrs.notification.subject()) {
      return;
    }
    return app.route.discussion(this.attrs.notification.subject());
  }

  content() {
    const notification = this.attrs.notification;
    const subject = notification.subject();
    const type = notification.content().type;
    let text = '';
    if (type == 1) {
      text = app.translator.trans('dl-response.forum.warn.discussion_be_delete',{title: subject.title()});
    } else if (type == 2) {
      text = app.translator.trans('dl-response.forum.warn.discussion_be_hide',{title: subject.title()});
    } else if (type == 3) {
      text = app.translator.trans('dl-response.forum.warn.discussion_be_restore',{title: subject.title()});
    } else if (type == 4) {
      text = app.translator.trans('dl-response.forum.warn.post_be_delete');
    } else if (type == 5) {
      text = app.translator.trans('dl-response.forum.warn.post_be_hide');
    }
    return text;

  }

}
